export default __webpack_public_path__ + "static/verbier-switzerland-photo-by-malte-karger-2f22cdd5d03f40c5f8347607ad68f203.jpg";